module.exports = __webpack_public_path__ + "static/media/icon_arrow_up.d28fa4e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/od-icons/icon_arrow_up.svg
// module id = 1051
// module chunks = 0